const site = require("../content/site.json");
const pages = require("../content/pages.json");
const missions = require("../content/missions.json");

function getPages() {
  return {
    ...pages,
    ...Object.fromEntries(missions.map((mission) => [mission.destination, {
      title: `${mission.title} — ${mission.date}`,
      description: `Read about the ${mission.date} Cyrenaeus surgical mission to ${mission.title} in ${mission.location}, supporting reconstructive care and clinical training.`,
    }])),
  };
}

function getMetadata(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  const page = getPages()[path];
  return {
    title: `${page ? page.title : "Page not found"} | ${site.name}`,
    description: page ? page.description : "The requested Cyrenaeus page could not be found.",
    url: new URL(path, site.url).href,
    image: new URL(site.image, site.url).href,
    imageAlt: site.imageAlt,
    siteName: site.name,
    robots: page ? "index, follow" : "noindex, follow",
  };
}

function getMetaTags(meta) {
  return [
    ["name", "description", meta.description],
    ["name", "robots", meta.robots],
    ["property", "og:type", "website"],
    ["property", "og:locale", "en_GB"],
    ["property", "og:site_name", meta.siteName],
    ["property", "og:title", meta.title],
    ["property", "og:description", meta.description],
    ["property", "og:url", meta.url],
    ["property", "og:image", meta.image],
    ["property", "og:image:alt", meta.imageAlt],
    ["name", "twitter:card", "summary_large_image"],
    ["name", "twitter:title", meta.title],
    ["name", "twitter:description", meta.description],
    ["name", "twitter:image", meta.image],
    ["name", "twitter:image:alt", meta.imageAlt],
  ];
}

module.exports = { getPages, getMetadata, getMetaTags };
